'use strict';

/**
 * @name thirdApps
 */

exports.installed = require('./installed.js');



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/thirdApps/index.js
// module id = 620
// module chunks = 0